import { OrderCodeTextInputComponent } from './order-code-text-input.component';
import { OrderModel } from './order.model';

/**
 * 受注コードテキストボックスManageクラス
 *
 * @export OrderCodeTextInputModel
 * @class OrderCodeTextInputModel
 */
export class OrderCodeTextInputModel {

  public orderList: OrderModel[] = [];

  /** テキストボックスインスタンス */
  public orderCodeTextInput: OrderCodeTextInputComponent;
  /** コードリスト取得完了 */
  public completeUpdateOrderCodeList: boolean = <boolean>false;

  /**
   * 発注コードリストアップデート
   *
   * @param serverData:サーバから取得された<Data>タグ
   */
  public updateOrderList(serverData: OrderModel[]) {
    if (serverData == null) {
      this.orderList = [];
      return;
    }
    this.orderList = serverData;

    this.completeUpdateOrderCodeList = true;
    this.orderCodeTextInput.changeOrderCodeHandler();
  }

}
